import React, { SyntheticEvent } from 'react';
import { Dropdown, DropdownItemProps } from 'semantic-ui-react';
import { Device, divisonAndOrdinaryAllowed } from '../logic/Device';
import { deepCopy } from '../logic/utils';
import { ColorDropdown } from '../ui/ColorDropdown';
import { ChargeDropdown } from '../ui/ChargeDropdown';
import { ChargePermutations } from '../logic/HeraldryAPI';

import './HeraldryWidget.css';
import './Field.css';


interface Props {
    device: Device | undefined,
    changeDevice: (device: Device) => void,
    options: ChargePermutations,
    historical: boolean;
}
interface State {
}

export class OrdinaryUI extends React.Component<Props, State> {
    static SHAPE_OPTIONS: DropdownItemProps[] = [
        { key: 'NONE', value: 'NONE', text: 'None' },
        { key: 'BEND', value: 'BEND', text: 'Bend', image: { src: require("../assets/ordinaries/BEND.png") } },
        { key: 'BEND_SINISTER', value: 'BEND_SINISTER', text: 'Bend Sinister', image: { src: require("../assets/ordinaries/BEND_SINISTER.png") } },
        { key: 'CHEVRON', value: 'CHEVRON', text: 'Chevron', image: { src: require("../assets/ordinaries/CHEVRON.png") } },
        { key: 'CROSS', value: 'CROSS', text: 'Cross', image: { src: require("../assets/ordinaries/CROSS.png") } },
        { key: 'FESS', value: 'FESS', text: 'Fess', image: { src: require("../assets/ordinaries/FESS.png") } },
        { key: 'PALE', value: 'PALE', text: 'Pale', image: { src: require("../assets/ordinaries/PALE.png") } },
        { key: 'SALTIRE', value: 'SALTIRE', text: 'Saltire', image: { src: require("../assets/ordinaries/SALTIRE.png") } },
    ];

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    public render() {
        if (!this.props.device) {
            return <div/>;
        }

        let nbrOptions: DropdownItemProps[] = [];
        for (const n of this.props.options.ordinary) {
            if (Number(n) !== 0) {
                nbrOptions.push({ key: n + "", text: n + "", value: n + "" });
            }
        }

        return <div>
            <p>
                An "ordinary" is an optional shape with its own color, placed atop the field and division.
                In some cases, the ordinary may have its own artwork.
            </p>

            <div className="heraldry-dropdown">
                <div className="heraldry-dropdown-label">Shape:</div>
                <div className="heraldry-dropdown-menus">
                    <div className="heraldry-dropdown-menu">
                        <Dropdown selection options={OrdinaryUI.SHAPE_OPTIONS} defaultValue={this.props.device.ordinary?.kind}
                            onChange={(event: SyntheticEvent, data: object) => this.onChangeOrdinaryShape((data as any).value)} />
                    </div>
                    <ColorDropdown disabled={!this.props.device.ordinary} historical={this.props.historical}
                        color={this.props.device.ordinary?.color} onChange={(color: string) => this.onChangeOrdinaryColor(color)} />
                </div>
            </div>

            <div className="heraldry-dropdown">
                <div className="heraldry-dropdown-label">Art:</div>
                <div className="heraldry-dropdown-menus">
                    <div>
                        <ChargeDropdown disabled={!this.props.device.ordinary || nbrOptions.length===0}
                            charge={this.props.device.ordinary?.charges?.name}
                            onChange={(charge: string | undefined) => this.onChangeOrdinaryCharge(charge)} />
                    </div>
                    <div className="heraldry-dropdown-menu">
                        <ColorDropdown disabled={!this.props.device.ordinary?.charges} historical={this.props.historical}
                            color={this.props.device.ordinary?.charges?.color} onChange={(color: string) => this.onChangeOrdinaryChargeColor(color)} />
                    </div>
                    <div className="heraldry-dropdown-menu">
                        <Dropdown compact selection options={nbrOptions} disabled={!this.props.device.ordinary?.charges} defaultValue='1'
                            onChange={(event: SyntheticEvent, data: object) => this.onChangeChargeNumber((data as any).value)} />
                    </div>
                </div>
            </div>

        </div>;
    }

    private onChangeOrdinaryShape(kind?: string) {
        const device: Device = deepCopy(this.props.device);
        console.log("Ordinary.onChangeOrdinaryShape: " + kind);
        if (!kind || kind === "NONE") {
            device.ordinary = undefined;
        } else {
            if (!device.ordinary) {
                device.ordinary = {
                    kind,
                    color: "GOLD",
                }
            }
            device.ordinary.kind = kind!;
        }

        if (!divisonAndOrdinaryAllowed(device.division?.kind, device.ordinary?.kind)) {
            device.division = undefined;
        }

        this.props.changeDevice(device);
    }

    private onChangeOrdinaryColor(color: string) {
        const device: Device = deepCopy(this.props.device);
        device.ordinary!.color = color!;
        this.props.changeDevice(device);
    }

    private onChangeOrdinaryCharge(name: string | undefined) {
        const device: Device = deepCopy(this.props.device);
        if (!name) {
            device.ordinary!.charges = undefined;
        } else {
            if (!device.ordinary!.charges) {
                device.ordinary!.charges = {
                    name,
                    color: "RED",
                    nbr: 1,
                }
            }
            device.ordinary!.charges.name = name!;
        }
        this.props.changeDevice(device);
    }

    private onChangeOrdinaryChargeColor(color: string) {
        const device: Device = deepCopy(this.props.device);
        device.ordinary!.charges!.color = color!;
        this.props.changeDevice(device);
    }

    private onChangeChargeNumber(n: number) {
        const device: Device = deepCopy(this.props.device);
        device.ordinary!.charges!.nbr = n;
        this.props.changeDevice(device);
    }

}
